'use client';
import Button from '@/common/components/shared/button';
import Layout from '@/common/components/shared/layout';
import { PORSLINE } from '@/common/constants/porsline';
import { useSurvey } from '@/common/providers/SurveyProvider';

export const Main = () => {
  const { openSurvey } = useSurvey();
  return (
    <Layout hasHeader hasFooter>
      <div className="rounded-2xl bg-[url(/assets/webp/shop-mobile.webp)] md:bg-[url(/assets/webp/shop-desktop.webp)] text-center min-h-[calc(100vh-44px)] md:min-h-[calc(100vh-120px)] bg-bottom bg-cover w-full bg-no-repeat px-6">
        <h1 className="text-2xl md:text-3xl font-extrabold leading-10 md:leading-16 mb-1.5 md:mb-4 mt-6 md:mt-10">
          بازارگاهی به وسعت تمام <br className="lg:hidden" /> کالاهای ویترو
        </h1>
        <p className="text-base md:text-lg font-medium leading-6 sm:leading-7 mb-6 max-w-226.25 mx-auto text-silver-50 text-justify lg:text-center">
          {
            'ویتروشاپ یه مارکت‌پلیس (Market Place) یا بازارگاه اینترنتیه که با داشتن هزاران محصول تنوع کافی رو برای خریداران آنلاین فراهم می‌کنه. از طرفی فروشنده‌ها هم می‌تونن خیلی ساده وارد ویتروشاپ بشن و محصولاتشون رو جلوی چشم هزاران خریدار بذارن. تو شرایطی که ورود بازارگاه‌ها سخت شده و رقابت سنگینه، ویتروشاپ فرصتیه برای اینکه فروشنده‌ها بهتر دیده بشن و راحت‌تر فروش آنلاین داشته باشن.'
          }
        </p>
        <div className="flex w-full flex-col justify-center items-center md:flex-row gap-2">
          <Button
            id="business-analysis"
            className="mt-0 lg:mt-4 text-base! md:text-lg leading-5 md:leading-7 w-full sm:w-fit"
            type="black-gradient"
            link="/"
            onClick={() => openSurvey(PORSLINE.feedback)}
          >
            تحلیل کسب و کار
          </Button>
          <Button
            id="site-creation"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-0 lg:mt-4 text-base! md:text-lg leading-5 md:leading-7 w-full sm:w-fit"
            type="big-white"
            link={process.env.NEXT_PUBLIC_WITRO_APP_URL}
          >
            ساخت سایت رایگان
          </Button>
        </div>
      </div>
    </Layout>
  );
};
